import type { UploadFile } from "antd/es/upload";

export const DOCUMENT_UPLOAD_ACCEPT = ".pdf,.png,.jpg,.jpeg,.webp";

export const DOCUMENT_UPLOAD_ALLOWED_TYPES = new Set([
  "application/pdf",
  "image/jpeg",
  "image/jpg",
  "image/png",
  "image/webp",
]);

export type DocumentPreviewState = {
  file: File;
  fileUrl: string;
  fileName: string;
};

export const formatDocumentFileSize = (bytes?: number): string => {
  if (bytes == null || bytes <= 0) return "";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

export const fileToUploadFile = (file: File, prefix = "doc"): UploadFile => ({
  uid: `${prefix}-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`,
  name: file.name,
  status: "done",
  originFileObj: file as UploadFile["originFileObj"],
});

export const isAllowedDocumentUpload = (
  file: File,
  allowedTypes: Set<string> = DOCUMENT_UPLOAD_ALLOWED_TYPES,
): boolean => allowedTypes.has(file.type);

export const revokeObjectUrl = (url?: string | null) => {
  if (url) URL.revokeObjectURL(url);
};
